/* source-map/source-map */ function _(require, module, exports) {
    /*
     * Copyright 2009-2011 Mozilla Foundation and contributors
     * Licensed under the New BSD license. See LICENSE.txt or:
     * http://opensource.org/licenses/BSD-3-Clause
     */
    exports.SourceMapGenerator = require(321) /* ./lib/source-map-generator */.SourceMapGenerator;
    exports.SourceMapConsumer = require(320) /* ./lib/source-map-consumer */.SourceMapConsumer;
    exports.SourceNode = require(322) /* ./lib/source-node */.SourceNode;
}
